<div class="w-full bg-[#1a1a1a] text-white flex flex-col rounded-lg max-w-lg max-h-[85vh]">
  <!-- Header -->
  <div class="flex-shrink-0 bg-[#1a1a1a] border-b border-zinc-800">
    <div class="flex items-center justify-between px-4 sm:px-6 py-4">
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center">
          <mat-icon svgIcon="heroicons_outline:banknotes" class="text-green-500 icon-size-5"></mat-icon>
        </div>
        <div>
          <span class="text-white/50 text-xs uppercase tracking-wider">Comissão</span>
          <p class="text-green-500 text-sm font-medium">Realizar Pagamento</p>
        </div>
      </div>
      <button
        mat-icon-button
        class="text-white/60 hover:text-white hover:bg-zinc-800 transition-colors"
        [disabled]="isLoading"
        (click)="fechar()">
        <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
      </button>
    </div>
  </div>

  <!-- Conteúdo Principal -->
  <div class="flex-1 overflow-y-auto p-4 sm:p-6 min-h-0">
    <!-- Informações do Parceiro -->
    <div class="mb-4 sm:mb-6">
      <h3 class="text-base sm:text-lg font-semibold text-white mb-3 sm:mb-4">Dados do Parceiro</h3>
      
      <div class="space-y-3 sm:space-y-4 bg-zinc-900/50 rounded-lg p-3 sm:p-4">
        <!-- Nome -->
        <div class="flex items-start gap-2 sm:gap-3">
          <div class="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-zinc-800 flex items-center justify-center flex-shrink-0">
            <mat-icon svgIcon="heroicons_outline:user" class="icon-size-4 text-white/60"></mat-icon>
          </div>
          <div class="min-w-0 flex-1">
            <span class="text-white/50 text-xs uppercase tracking-wider">Nome</span>
            <p class="text-white font-medium text-sm sm:text-base truncate">{{ data.nomeParceiro }}</p>
          </div>
        </div>

        <!-- E-mail -->
        <div class="flex items-start gap-2 sm:gap-3">
          <div class="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-zinc-800 flex items-center justify-center flex-shrink-0">
            <mat-icon svgIcon="heroicons_outline:envelope" class="icon-size-4 text-white/60"></mat-icon>
          </div>
          <div class="min-w-0 flex-1">
            <span class="text-white/50 text-xs uppercase tracking-wider">E-mail</span>
            <p class="text-white font-medium text-sm sm:text-base truncate">{{ data.emailParceiro }}</p>
          </div>
        </div>

        <!-- Chave PIX -->
        <div class="flex items-start gap-2 sm:gap-3">
          <div class="w-7 h-7 sm:w-8 sm:h-8 rounded-full bg-zinc-800 flex items-center justify-center flex-shrink-0">
            <mat-icon svgIcon="heroicons_outline:key" class="icon-size-4 text-white/60"></mat-icon>
          </div>
          <div class="flex-1 min-w-0">
            <span class="text-white/50 text-xs uppercase tracking-wider">Chave PIX (CPF/CNPJ)</span>
            <div class="flex items-center gap-2">
              <p class="text-[#E4811E] font-medium font-mono text-sm sm:text-base truncate">{{ data.chavePix }}</p>
              <button
                mat-icon-button
                class="!w-7 !h-7 sm:!w-8 sm:!h-8 text-white/60 hover:text-[#E4811E] transition-colors flex-shrink-0"
                (click)="copiarChavePix()"
                matTooltip="Copiar chave PIX">
                <mat-icon svgIcon="heroicons_outline:clipboard-document" class="icon-size-4"></mat-icon>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Informações da Comissão -->
    <div class="mb-4 sm:mb-6">
      <h3 class="text-base sm:text-lg font-semibold text-white mb-3 sm:mb-4">Dados da Comissão</h3>
      
      <div class="grid grid-cols-2 gap-3 sm:gap-4 bg-zinc-900/50 rounded-lg p-3 sm:p-4">
        <!-- Imobiliária -->
        <div>
          <span class="text-white/50 text-xs uppercase tracking-wider">Imobiliária</span>
          <p class="text-white font-medium text-sm sm:text-base truncate">{{ data.nomeImobiliaria }}</p>
        </div>

        <!-- Valor -->
        <div>
          <span class="text-white/50 text-xs uppercase tracking-wider">Valor da Comissão</span>
          <p class="text-green-500 font-bold text-lg sm:text-xl">
            R$ {{ data.valorComissao | number:'1.2-2':'pt-BR' }}
          </p>
        </div>
      </div>
    </div>

    <!-- Upload do Comprovante -->
    <div class="mb-4 sm:mb-6">
      <h3 class="text-base sm:text-lg font-semibold text-white mb-3 sm:mb-4">Comprovante de Pagamento</h3>
      
      <form [formGroup]="form">
        @if (!arquivoSelecionado) {
          <div
            class="border-2 border-dashed border-zinc-700 rounded-lg p-4 sm:p-8 text-center hover:border-[#E4811E] transition-colors cursor-pointer"
            (click)="fileInput.click()">
            <div class="flex flex-col items-center gap-2 sm:gap-3">
              <div class="w-12 h-12 sm:w-16 sm:h-16 rounded-full bg-zinc-800 flex items-center justify-center">
                <mat-icon svgIcon="heroicons_outline:cloud-arrow-up" class="icon-size-6 sm:icon-size-8 text-white/40"></mat-icon>
              </div>
              <div>
                <p class="text-white font-medium text-sm sm:text-base">Clique para selecionar o comprovante</p>
                <p class="text-white/50 text-sm">Apenas arquivos PDF (máx. 5MB)</p>
              </div>
            </div>
          </div>
        } @else {
          <div class="bg-zinc-900/50 rounded-lg p-4 flex items-center justify-between">
            <div class="flex items-center gap-3">
              <div class="w-10 h-10 rounded-full bg-green-500/20 flex items-center justify-center">
                <mat-icon svgIcon="heroicons_outline:document-check" class="text-green-500 icon-size-5"></mat-icon>
              </div>
              <div>
                <p class="text-white font-medium truncate max-w-[200px]">{{ arquivoSelecionado.name }}</p>
                <p class="text-white/50 text-sm">{{ (arquivoSelecionado.size / 1024) | number:'1.0-0' }} KB</p>
              </div>
            </div>
            <button
              mat-icon-button
              class="text-red-400 hover:text-red-300 transition-colors"
              [disabled]="isLoading"
              (click)="removerArquivo()">
              <mat-icon svgIcon="heroicons_outline:trash" class="icon-size-5"></mat-icon>
            </button>
          </div>
        }

        <input
          #fileInput
          type="file"
          accept=".pdf"
          class="hidden"
          (change)="onFileSelected($event)"
        />
      </form>
    </div>
  </div>

  <!-- Footer com botões -->
  <div class="flex-shrink-0 border-t border-zinc-800 px-4 sm:px-6 py-4 flex flex-col sm:flex-row justify-between items-center gap-3">
    <button
      mat-flat-button
      class="bg-zinc-700 hover:bg-zinc-600 text-white w-full sm:w-auto order-2 sm:order-1"
      [disabled]="isLoading"
      (click)="fechar()">
      <mat-icon svgIcon="heroicons_outline:x-mark" class="mr-2 icon-size-4"></mat-icon>
      Cancelar
    </button>

    <button
      mat-flat-button
      color="primary"
      class="!bg-green-600 hover:!bg-green-500 w-full sm:w-auto order-1 sm:order-2"
      [disabled]="form.invalid || isLoading"
      (click)="realizarPagamento()">
      @if (isLoading) {
        <ng-container>
          <mat-spinner diameter="20" class="mr-2"></mat-spinner>
          Processando...
        </ng-container>
      } @else {
        <ng-container>
          <mat-icon svgIcon="heroicons_outline:check-circle" class="mr-2 icon-size-4"></mat-icon>
          Realizar Pagamento
        </ng-container>
      }
    </button>
  </div>
</div>
